import { GetRowCapabilities } from "../editorCapabilities";
import { NestedEditorRow } from "../nested/nestedRowTypes";

interface RemoveOpeningBalanceModalPropsData {
    accountName: string;
    targets: Array<{ entityId: number; accountId: string }>;
    // Unique entityIds of every constituent, in constituent order: a business
    // with no balance lands in the modal's nothing-will-change block.
    rowEntityIds: number[];
}

interface BuildRemoveOpeningBalanceModalPropsParams {
    row: NestedEditorRow;
    // Unwrapped per-account producer: the OR'd row object cannot classify
    // constituents on their own.
    getRowCapabilities: GetRowCapabilities;
}

export const buildRemoveOpeningBalanceModalProps = ({
    row,
    getRowCapabilities,
}: BuildRemoveOpeningBalanceModalPropsParams): RemoveOpeningBalanceModalPropsData => ({
    accountName: row.name,
    targets: row.accounts
        .filter((account) => getRowCapabilities(account).hasOpeningBalance)
        .map((account) => ({
            entityId: account.entityId,
            accountId: account.id,
        })),
    rowEntityIds: Array.from(
        new Set(row.accounts.map((account) => account.entityId)),
    ),
});
